// @ts-nocheck
import {
    getBillingStatusFiltersOpen,
    getLedgersParameter,
} from "@store/Framework/Store/Store/Pages/BillingStatus/BillingStatusSelector";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useLedgersParameter = convertSelectorToHook(getLedgersParameter);

export const useBillingStatusFiltersOpen = convertSelectorToHook(getBillingStatusFiltersOpen);
